import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { replace } from 'react-router-redux';
import OrganizationList from '../components/OrganizationList';
import { loadKeywordSearchResults } from '../actions';
import OrganizationsPagination from '../components/OrganizationsPagination';
import { asyncActions } from 'react-async-actions'
import { SearchForm } from '../components/header/Search'


const actionsToFire = (props) => {
  if (props.location.query.q) {
    return [props.loadKeywordSearchResults(props.location.query.q)]
  }
}


@connect(
  state => (state), // Can be replaces by mapStateToProps function as well.
  {
    replace,
    loadKeywordSearchResults
  }
)
@asyncActions(actionsToFire)
class SearchResultList extends Component {

  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(nextProps) {
    let nextQ = nextProps.location.query.q;
    let prevQ = this.props.location.query.q;
    if(nextQ && nextQ != prevQ) {
      nextProps.loadKeywordSearchResults(nextQ);
    }
  }

  previousPage = e => {
    e.preventDefault();
    const { previous, count, limit, offset } = this.props.keywordSearchResults;
    const q = this.props.location.query.q;
    if(previous) {
      this.props.loadKeywordSearchResults(q, limit, offset - limit);
    }
  }

  nextPage = e => {
    e.preventDefault();
    const { next, limit, offset, count } = this.props.keywordSearchResults;
    const q = this.props.location.query.q;
    if(next) {
      this.props.loadKeywordSearchResults(q, limit, offset + limit);
    }
  }

  pageJump = (number, e) => {
    const { count, limit, offset } = this.props.keywordSearchResults;
    const q = this.props.location.query.q;
    const maxOffset =  count - limit;
    let newOffset = number * limit - 10;
    if(newOffset > maxOffset) {
      newOffset = maxOffset;
    }
    this.props.loadKeywordSearchResults(q, limit, newOffset);
  }

  render() {
    let q = this.props.location.query.q;
    let description = '';

    if(!this.props.keywordSearchResults.isLoading && this.props.keywordSearchResults.count > 0) {
      description = (
        <div className="search-description">
          {this.props.keywordSearchResults.count} matches found for <Link to={`/search/?q=${q}`}><em><strong>{q}</strong></em></Link>.
          Showing matches {this.props.keywordSearchResults.offset + 1} to {this.props.keywordSearchResults.limit * (this.props.keywordSearchResults.offset + 1)}.
        </div>
        )
    } else if (this.props.keywordSearchResults.isLoading) {
      description = <div className="search-description">Searching...</div>
    } else {
      description = <div className="search-description zeroresults"> No matches found for <em>{q}</em> </div>
    }



    return <div className="search-inner">
      <div className="content-wrapper">

        {description}
        <OrganizationsPagination organizations={this.props.keywordSearchResults}
                                  pageJump={this.pageJump}
                                  nextPage={this.nextPage}
                                  previousPage={this.previousPage} />
        <OrganizationList user={this.props.auth.user} organizations={this.props.keywordSearchResults} />
        <OrganizationsPagination organizations={this.props.keywordSearchResults}
                                  pageJump={this.pageJump}
                                  nextPage={this.nextPage}
                                  previousPage={this.previousPage} />
      </div>
    </div>;
  }

}

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    replace,
    loadKeywordSearchResults
  }
)(SearchResultList);



// WEBPACK FOOTER //
// ./src/containers/SearchList.jsx